import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { LocaleService } from '@next/core-lib/i18n';
import { filter, map } from 'rxjs/operators';

import { routeAnimations } from '../../../animations';
import { EmployeeService } from '../../services/employee.service';

@Component({
  selector: 'app-employee-item',
  templateUrl: './employee-item.component.html',
  animations: [routeAnimations],
  standalone: false,
})
export class EmployeeItemComponent {
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly locale = inject(LocaleService);
  private readonly employeeService = inject(EmployeeService);

  readonly routeAnimationState = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map(() => this.route.firstChild?.routeConfig?.data ?? false),
    ),
    { initialValue: this.route.firstChild?.routeConfig?.data ?? false },
  );

  readonly employee = toSignal(
    this.employeeService.watchEmployee(
      this.route.paramMap.pipe(
        map((params) => Number(params.get('employeeId'))),
        filter((employeeId) => !Number.isNaN(employeeId)),
      ),
    ),
    { initialValue: undefined },
  );

  readonly pageTitle = computed(() => {
    const employee = this.employee();
    if (!employee) {
      return '';
    }

    return `${this.locale.translate('app.employee.edit-employee')} ${employee.firstName} ${employee.lastName}`;
  });

  back = () => this.router.navigate(['/employees']);
}
